import React, { FC } from 'react';
import cx from 'clsx';

import styles from './PerksDescriptionModal.module.scss';
import { PERKS_DESCRIPTION_MODAL } from './PerksDescriptionModal.const';
import { Perk } from 'hooks/context/Perks.model';
import { PerkImage } from './PerkImage';
import { PerkProgress } from './PerkProgress';
import Typography from 'components/Typography/Typography';
import { useTranslation } from 'react-i18next';
import { usePerks } from 'hooks/context/Perks';
import { isFutureDate } from '../util/Date';
import { DateTime } from 'luxon';

type PerkDescriptionModalBodyProps = React.HTMLAttributes<HTMLDivElement> & {
  className?: string;
  selectedPerk: Perk;
};

export const PerkDescriptionModalBody: FC<PerkDescriptionModalBodyProps> = ({ className, selectedPerk }) => {
  const { t } = useTranslation();
  const { merchantTimezone } = usePerks();
  const futurePerk = selectedPerk.startsAt && merchantTimezone ? isFutureDate(selectedPerk.startsAt, merchantTimezone): false;
  const perkStartsAt = selectedPerk.startsAt && DateTime.fromMillis(parseInt(selectedPerk.startsAt), { zone: merchantTimezone }).toFormat('LLL dd');
  const perkEndsAt = selectedPerk.endsAt && DateTime.fromMillis(parseInt(selectedPerk.endsAt), { zone: merchantTimezone }).toFormat('LLL dd');
  const subtitle = selectedPerk.available && selectedPerk.perkType === 'POINT'? selectedPerk.required + t('perksDescriptionModal.points'): selectedPerk.subtitle;

  return (
    <div className={styles.container}>
        <div className={cx(styles.perkSection, className)} data-testid={PERKS_DESCRIPTION_MODAL.perkSection}>
          <div className={styles.descriptionHeader}>
            <PerkImage
              iconUrl={selectedPerk.iconUrl}
              backgroundIconUrl={selectedPerk.backgroundIconUrl}
              className={cx(styles.icon, {
                [styles.iconDisable]: futurePerk,
              })}
            />
              <Typography.Heading1
                aria-live={'polite'}
                disabled ={futurePerk ? true : false}
              >
                {selectedPerk.title}
              </Typography.Heading1>
            <Typography.Heading2>
              {subtitle && <p className={cx(styles.alignCenter)} data-testid={PERKS_DESCRIPTION_MODAL.subtitle}>
                {subtitle}
              </p>}
            {futurePerk ? selectedPerk.startsAt && (
                  <p data-testid={PERKS_DESCRIPTION_MODAL.startsAt}>
                    {t('perksDescriptionModal.startsAt')} {perkStartsAt}
                  </p>
                )
              : selectedPerk.endsAt && (
                  <p data-testid={PERKS_DESCRIPTION_MODAL.endsAt}>
                    {t('perksDescriptionModal.endsAt')} {perkEndsAt}
                  </p>
                )}
              </Typography.Heading2>
          </div>
            {!selectedPerk.available && (
              <PerkProgress
                className={styles.modalProgress}
                perkType={selectedPerk.perkType}
                earned={selectedPerk.earned}
                required={selectedPerk.required}
                complete={selectedPerk.available}
              />
            )}
            {selectedPerk.restrictions && <>
            <Typography.Body variant="primary">
              <p className={styles.terms}>{t('perksDescriptionModal.termsTitle')}</p>
            </Typography.Body>
            <Typography.Body variant="secondary" color={'gray'}>
            <p>{selectedPerk.restrictions}</p>
          </Typography.Body>
          </>}
        </div>
    </div>
  );
};
